export const STEP_DURATION_MS = 6000;
export const FADE_DURATION_S = 0.6;

export const INTRO_ANIMATION_POSITION = [
  {
    left: 9,
    top: 5,
    size: 24,
  },
  {
    left: 91,
    top: 23,
    size: 19,
  },
  {
    left: 79,
    top: 57,
    size: 24,
  },
  {
    left: 35,
    top: 66,
    size: 19,
  },
  {
    left: 9,
    top: 78,
    size: 21,
  },
];

export const DEFAULT_STEPS: {
  startColor: string;
  endColor: string;
}[] = [
  {
    startColor: "#C34D6F",
    endColor: "#E497A8",
  },
  {
    startColor: "#733B7C",
    endColor: "#955A9F",
  },
  {
    startColor: "#44679C",
    endColor: "#7096C4",
  },
  {
    startColor: "#328161",
    endColor: "#65B592",
  },
  {
    startColor: "#901E41",
    endColor: "#BB395D",
  },
  {
    startColor: "#4D215E",
    endColor: "#A14EAC",
  },
  {
    startColor: "#213760",
    endColor: "#2A4B84",
  },
];
